import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';

export const defaultCollectionSort = [Order.asc(OrderKeys.name)];

export const collectionsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'itemCount': createNonDisplayOptionDefinition('itemCount', OrderKeys.itemCount),
  'visibility': createNonDisplayOptionDefinition('visibility', OrderKeys.visibility),
  'createdAt': SortOptions.createdAt
};
